export default {
  INSUFFICIENT_STOCK: 'Estoque indisponível.',
  SOMETHING_WRONG: 'Não foi possível calcular o frete. Tente novamente.'
};